document.addEventListener('DOMContentLoaded', function () {


  document.querySelectorAll('.variant-dropdown-wrapper').forEach(wrapper => {
    const toggle = wrapper.querySelector('.variant-header');
    const list = wrapper.querySelector('.variant-list');
    const arrow = wrapper.querySelector('.arrow');

    toggle.addEventListener('click', () => {
      if (list.style.display === 'block') {
        slideUp(list);
        arrow.classList.remove('rotate');
        wrapper.classList.remove('open'); 
      } else {
        slideDown(list);
        arrow.classList.add('rotate');
        wrapper.classList.add('open'); 
      }
    });
  });

  const accordionTitles = document.querySelectorAll(".accordion__label");
  accordionTitles.forEach(title => {
    title.addEventListener("click", function (e) {
      e.preventDefault();

      const currentGroup = this.closest(".accordion__group");
      const currentText = currentGroup.querySelector(".accordion__text");

      // Close all other open accordions
      document.querySelectorAll(".accordion__group").forEach(group => {
        if (group !== currentGroup) {
          group.classList.remove("active");
          const text = group.querySelector(".accordion__text");
          if (text) slideUp(text);
        }
      });

      // Toggle current one
      if (currentGroup.classList.contains("active")) {
        currentGroup.classList.remove("active");
        slideUp(currentText);
      } else {
        currentGroup.classList.add("active");
        slideDown(currentText);
      }
    });
  });

  function slideDown(element) {
    element.style.display = "block";
    const height = element.scrollHeight + "px";
    element.style.height = "0";
    element.style.transition = "height 0.3s ease-out, opacity 0.3s ease-out";
    element.style.overflow = "hidden";

    requestAnimationFrame(() => {
      element.style.height = height;
      element.style.opacity = "1";
    });
  }

  function slideUp(element) {
    element.style.transition = "height 0.3s ease-in, opacity 0.3s ease-in";
    const height = element.scrollHeight + "px";
    element.style.height = height;
    element.style.opacity = "0";

    requestAnimationFrame(() => {
      element.style.height = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
      element.style.height = "";
      element.style.opacity = "1";
      element.style.overflow = "";
      element.style.transition = "";
    }, 300);
  }

  const marqueeContent = document.querySelector(".text-marquee-content");
  const marqueeInner = document.querySelector(".text-marquee-inner");

  if (marqueeContent && marqueeInner) {
    const clone = marqueeContent.cloneNode(true);
    marqueeInner.appendChild(clone);
  }

});
